var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRacing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.823 24.502"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-racing_svg__a{stroke:currentColor;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.75 .751)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-racing_svg__Icons",
    transform: "translate(14.124 4.965)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-racing_svg__a",
    id: "icon-racing_svg__Shape_121",
    "data-name": "Shape 121",
    d: "M330.3 288.352a.25.25 0 01.25.25",
    transform: "translate(-330.046 -288.352)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-racing_svg__a",
    id: "icon-racing_svg__Shape_122",
    "data-name": "Shape 122",
    d: "M330.046 288.6a.25.25 0 01.25-.248",
    transform: "translate(-330.046 -288.352)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-racing_svg__a",
    id: "icon-racing_svg__Shape_123",
    "data-name": "Shape 123",
    d: "M330.3 288.852a.251.251 0 01-.178-.073.248.248 0 01-.072-.177",
    transform: "translate(-330.046 -288.352)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "icon-racing_svg__a",
    id: "icon-racing_svg__Shape_124",
    "data-name": "Shape 124",
    d: "M330.546 288.6a.249.249 0 01-.25.25",
    transform: "translate(-330.046 -288.352)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-racing_svg__Text"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon-racing_svg__a",
    id: "icon-racing_svg__Path_6",
    "data-name": "Path 6",
    d: "M326.238 290.659c.042 2.241 3.044 2.79 5.2 2.918a14.364 14.364 0 014.271 1.056c.931-.8 1.861-1.776 1.4-2.253a8.458 8.458 0 01-2.875-3.37c-.888-1.774-1.5-1.5-2.382-2.457s.648-3.166.648-3.166a6 6 0 00-3.3 1.015s-5.2-2.117-10.485 3.212l1.607.613s-2.452 1.019-4.4 5.658l1.86-.053s-.222 4.865 2.718 6.719c7.175 4.525 10.938 3.674 12.968 5.836 0 0 .9-3.348-3.8-8.264-2.495-2.607-1.211-5.058-1.211-5.058",
    transform: "translate(-315.922 -283.387)",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMi44MjMgMjQuNTAyIj4KCTxkZWZzPgoJCTxzdHlsZT4KCQkJLmF7c3Ryb2tlOmN1cnJlbnRDb2xvcjtzdHJva2Utd2lkdGg6MS41cHh9CgkJPC9zdHlsZT4KCTwvZGVmcz4KCTxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNzUgMC43NTEpIj4KCQk8ZyBpZD0iSWNvbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0LjEyNCA0Ljk2NSkiPgoJCQk8cGF0aCBjbGFzcz0iYSIgaWQ9IlNoYXBlXzEyMSIgZGF0YS1uYW1lPSJTaGFwZSAxMjEiIGQ9Ik0zMzAuMywyODguMzUyYS4yNS4yNSwwLDAsMSwuMjUuMjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMzAuMDQ2IC0yODguMzUyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiIC8+CgkJCTxwYXRoIGNsYXNzPSJhIiBpZD0iU2hhcGVfMTIyIiBkYXRhLW5hbWU9IlNoYXBlIDEyMiIgZD0iTTMzMC4wNDYsMjg4LjZhLjI1LjI1LDAsMCwxLC4yNS0uMjQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzMwLjA0NiAtMjg4LjM1MikiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIiAvPgoJCQk8cGF0aCBjbGFzcz0iYSIgaWQ9IlNoYXBlXzEyMyIgZGF0YS1uYW1lPSJTaGFwZSAxMjMiIGQ9Ik0zMzAuMywyODguODUyYS4yNTEuMjUxLDAsMCwxLS4xNzgtLjA3My4yNDguMjQ4LDAsMCwxLS4wNzItLjE3NyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMzMC4wNDYgLTI4OC4zNTIpIiBmaWxsPSJub25lIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMSIgLz4KCQkJPHBhdGggY2xhc3M9ImEiIGlkPSJTaGFwZV8xMjQiIGRhdGEtbmFtZT0iU2hhcGUgMTI0IiBkPSJNMzMwLjU0NiwyODguNmEuMjQ5LjI0OSwwLDAsMS0uMjUuMjUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zMzAuMDQ2IC0yODguMzUyKSIgZmlsbD0ibm9uZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjEiIC8+CgkJPC9nPgoJCTxnIGlkPSJUZXh0Ij4KCQkJPHBhdGggY2xhc3M9ImEiIGlkPSJQYXRoXzYiIGRhdGEtbmFtZT0iUGF0aCA2IiBkPSJNMzI2LjIzOCwyOTAuNjU5Yy4wNDIsMi4yNDEsMy4wNDQsMi43OSw1LjIsMi45MThhMTQuMzY0LDE0LjM2NCwwLDAsMSw0LjI3MSwxLjA1NmMuOTMxLS44LDEuODYxLTEuNzc2LDEuNC0yLjI1M2E4LjQ1OCw4LjQ1OCwwLDAsMS0yLjg3NS0zLjM3Yy0uODg4LTEuNzc0LTEuNS0xLjUtMi4zODItMi40NTdzLjY0OC0zLjE2Ni42NDgtMy4xNjZhNiw2LDAsMCwwLTMuMywxLjAxNXMtNS4yLTIuMTE3LTEwLjQ4NSwzLjIxMmwxLjYwNy42MTNzLTIuNDUyLDEuMDE5LTQuNCw1LjY1OGwxLjg2LS4wNTNzLS4yMjIsNC44NjUsMi43MTgsNi43MTljNy4xNzUsNC41MjUsMTAuOTM4LDMuNjc0LDEyLjk2OCw1LjgzNiwwLDAsLjktMy4zNDgtMy44LTguMjY0LTIuNDk1LTIuNjA3LTEuMjExLTUuMDU4LTEuMjExLTUuMDU4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzE1LjkyMiAtMjgzLjM4NykiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIiAvPgoJCTwvZz4KCTwvZz4KPC9zdmc+Cg==";
export { SvgIconRacing as ReactComponent };